<div class="login-container">
  <div class="background">
    <div class="gradient-overlay"></div>
    <div class="particles">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
    </div>
  </div>

  <div class="login-panel">
    <div class="login-panel-left">
      <div class="brand-logo">
        <svg viewBox="0 0 24 24" class="logo-icon">
          <path
            d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"
          ></path>
        </svg>
        <span class="logo-text">Markado</span>
      </div>
      <div class="illustration">
        <div class="illustration-circle"></div>
        <div class="illustration-shape shape-1"></div>
        <div class="illustration-shape shape-2"></div>
        <div class="illustration-shape shape-3"></div>
      </div>
      <div class="welcome-text">
        <h1>Welcome back</h1>
        <p>Sign in to access your account and dashboard</p>
      </div>
    </div>

    <div class="login-panel-right">
      <div class="login-header">
        <h2>Sign In</h2>
        <p>Enter your credentials to continue</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
        <div
          class="form-group"
          [class.form-error]="
            email?.invalid && (email?.dirty || email?.touched)
          "
        >
          <label for="email">Email</label>
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24">
              <path
                d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"
              ></path>
            </svg>
            <input
              type="email"
              id="email"
              formControlName="email"
              placeholder="you@example.com"
              [class.is-invalid]="
                email?.invalid && (email?.dirty || email?.touched)
              "
            />
          </div>
          <div
            class="error-text"
            *ngIf="email?.invalid && (email?.dirty || email?.touched)"
          >
            <div *ngIf="email?.errors?.['required']">Email is required</div>
            <div *ngIf="email?.errors?.['email']">
              Please enter a valid email address
            </div>
          </div>
        </div>

        <div
          class="form-group"
          [class.form-error]="
            password?.invalid && (password?.dirty || password?.touched)
          "
        >
          <div class="label-row">
            <label for="password">Password</label>
            <a routerLink="/forgot-password" class="forgot-link"
              >Forgot password?</a
            >
          </div>
          <div class="input-wrapper">
            <svg class="input-icon" viewBox="0 0 24 24">
              <path
                d="M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z"
              ></path>
            </svg>
            <input
              [type]="showPassword ? 'text' : 'password'"
              id="password"
              formControlName="password"
              placeholder="••••••••"
              [class.is-invalid]="
                password?.invalid && (password?.dirty || password?.touched)
              "
            />
            <button
              type="button"
              class="toggle-password"
              (click)="togglePasswordVisibility()"
              tabindex="-1"
            >
              <svg class="eye-icon" viewBox="0 0 24 24" *ngIf="!showPassword">
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <circle cx="12" cy="10" r="2"></circle>
              </svg>
              <svg class="eye-icon" viewBox="0 0 24 24" *ngIf="showPassword">
                <path
                  d="M12 6c-5.33 0-9.67 4-9.67 4s4.33 4 9.67 4 9.67-4 9.67-4-4.33-4-9.67-4zm0 6.67c-1.47 0-2.67-1.2-2.67-2.67S10.53 7.33 12 7.33s2.67 1.2 2.67 2.67-1.2 2.67-2.67 2.67z"
                ></path>
                <line
                  x1="4"
                  y1="4"
                  x2="20"
                  y2="20"
                  stroke="currentColor"
                  stroke-width="2"
                ></line>
              </svg>
            </button>
          </div>
          <div
            class="error-text"
            *ngIf="password?.invalid && (password?.dirty || password?.touched)"
          >
            <div *ngIf="password?.errors?.['required']">
              Password is required
            </div>
          </div>
        </div>

        <div class="form-group" *ngIf="showCaptcha">
          <app-recaptcha
            (tokenChange)="onRecaptchaChange($event)"
            (error)="onRecaptchaError($event)"
            [errorMessage]="recaptchaErrorMessage"
          >
          </app-recaptcha>
        </div>

        <div class="security-notice" *ngIf="showCaptcha && !errorMessage">
          <div class="notice-icon">
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
            >
              <path
                d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126zM12 15.75h.007v.008H12v-.008z"
              />
            </svg>
          </div>
          <span
            >Security verification required due to multiple failed login
            attempts.</span
          >
        </div>

        <div class="alert alert-error" *ngIf="errorMessage">
          <svg class="alert-icon" viewBox="0 0 24 24">
            <circle cx="12" cy="12" r="10"></circle>
            <line x1="12" y1="8" x2="12" y2="12"></line>
            <line x1="12" y1="16" x2="12.01" y2="16"></line>
          </svg>
          <span>{{ errorMessage }}</span>
        </div>

        <button
          type="submit"
          class="signin-button"
          [disabled]="
            isSubmitting ||
            loginForm.invalid ||
            (showCaptcha && !recaptchaToken)
          "
        >
          <span *ngIf="!isSubmitting">Sign In</span>
          <div class="spinner" *ngIf="isSubmitting">
            <div class="bounce1"></div>
            <div class="bounce2"></div>
            <div class="bounce3"></div>
          </div>
        </button>

        <div class="divider">
          <span>or continue with</span>
        </div>

        <div class="social-providers">
          <button
            type="button"
            (click)="openGoogleOAuth()"
            class="social-button google"
            [disabled]="isSubmitting"
          >
            <svg viewBox="0 0 24 24" class="social-icon">
              <path
                d="M12.545 10.239v3.821h5.445c-.712 2.315-2.647 3.972-5.445 3.972a6.033 6.033 0 110-12.064c1.498 0 2.866.549 3.921 1.453l2.814-2.814A9.969 9.969 0 0012.545 2C7.021 2 2.543 6.477 2.543 12s4.478 10 10.002 10c8.396 0 10.249-7.85 9.426-11.748l-9.426-.013z"
              ></path>
            </svg>
            <span>Google</span>
          </button>
        </div>

        <div class="signup-prompt">
          <span>Don't have an account?</span>
          <a routerLink="/register" class="signup-link">Create Account</a>
        </div>

        <div class="continue-prompt">
          <a routerLink="/home" class="continue-link"
            >Continue without an account</a
          >
        </div>
      </form>
    </div>
  </div>
</div>
